module.exports = __webpack_public_path__ + "img/cbs.192dcf33.svg";